<template>
    <div class="admin__balance balance widget" v-if="balance !== undefined">
        <div class="widget__name">
            <span class="balance__mtext">Ваш текущий баланс</span>
            <span class="balance__amount">{{ balance }} руб.</span>
        </div>
        <form class="balance__body form" v-if="userType !== 'patient'">
            <span class="field__hint">Денежные средства будут переведены по реквизитам, указанным в профиле, не позднее пятого числа месяца, следующего за отчётным</span>
        </form>
        <form class="balance__body form" @submit.prevent="fill()" v-else>
            <div class="balance__field">
                <label class="field">
                    <span class="field__caption">Введите сумму:</span>
                    <input v-model="price" name="price" class="field__input r-text-input" required>
                </label>
                <button v-if="balance > 0" @click="debit" type="button" class="balance__out r-button button">Вывести денежные средства</button>
            </div>
            <button type="submit" class="balance__button r-button button">Пополнить баланс</button>
        </form>
    </div>
</template>

<script>
    import api from "../../../../admin/api/api";

    export default {
        name: "Balance",
        data() {
            return {
                balance: null,
                price: null,
            }
        },
        props: {
            userType: {
                required: true
            }
        },
        mounted() {
            this.getBalance();
        },
        methods: {
            getBalance() {
                api.get('/api/widget/balance')
                    .then((response) => {
                        this.balance = response.data;
                    })
                    .catch(error => alert(error))
            },
            fill() {
                const params = new URLSearchParams({
                    price: this.price
                });

                window.location.href = `/account/balance/fill?${params.toString()}`;
            },
            debit() {
                window.location.href = `/account/balance/debit`;
            }
        }
    }
</script>
